import React, { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from '@mui/material';
import { MDBCol, MDBRow } from "mdbreact";
import { AbsDropDown, Button, Input, TextArea, Icon, ICONS, } from "abs-ui-components";
import AsyncSelect from 'react-select/async';

const DynamicTableForm = (props) => {
    const {fields,payload,setPayload} = props;
    const [groupIdCounter, setGroupIdCounter] = useState(2);
    const [B3FormFields, setB3FormFields] = useState([]);
    const [savedData, setSavedData] = useState([]);
    const [isEditing, setIsEditing] = useState(null);

    const addFormGroup = () => {
        setB3FormFields((prevFields) => [
            ...prevFields,
            {
                groupId: groupIdCounter,
                fields: fields,
            },
        ]);
        setGroupIdCounter((prevCounter) => prevCounter + 1);
        setIsEditing(null);
    };

    const handleEditB3Form = (groupId, fieldName, newData) => {
        setB3FormFields((prevFields) =>
            prevFields.map((group) =>
                group.groupId === groupId
                    ? {
                        ...group,
                        fields: group.fields.map((field) =>
                            field.name === fieldName
                                ? { ...field, ...newData }
                                : field
                        ),
                    }
                    : group
            )
        );
    };

    const constructDynamicPayload=(data)=>{
        let result={};
        data.length>0 && Object.keys(data[0].fields).forEach(keyValue=>result[keyValue]=[]);
        data.forEach(item=>{
            Object.keys(item.fields).forEach(field=>result[`${field}`].push(item.fields[field]))
        })
        setPayload({...payload,...result})
        
    }

    const handleSaveGroup = (groupId) => {
        const groupToSave = B3FormFields.find(
            (group) => group.groupId === groupId
        );

        if (groupToSave) {
                let filterData=[];
                setSavedData((prevData) => {
                const existingData = prevData.find(
                    (data) => data.groupId === groupId
                );
                if (existingData) {
                    filterData = prevData.map((data) =>
                        data.groupId === groupId
                            ? {
                                groupId: groupToSave.groupId,
                                fields: groupToSave.fields.reduce(
                                    (acc, field) => {
                                        acc[field.name] = field.value;
                                        return acc;
                                    },
                                    {}
                                ),
                            }
                            : data
                    );

                    return filterData;
                } else {
                    filterData = [
                        ...prevData,
                        {
                            groupId: groupToSave.groupId,

                            fields: groupToSave.fields.reduce((acc, field) => {
                                acc[field.name] = field.value;
                                return acc;
                            }, {}),
                        },
                    ];
                    return filterData;
                }
            });
            const updated_fields=constructDynamicPayload(filterData);
            if (B3FormFields.length === 1) {
                setB3FormFields([
                    {
                        groupId: groupIdCounter,
                        fields: fields,
                    },
                ]);
            } else {
                let updatedFormFields = B3FormFields.filter(
                    (form) => form.groupId !== groupId
                );
                setB3FormFields(updatedFormFields);
            }

            setGroupIdCounter((prevCounter) => prevCounter + 1);
            setIsEditing(null);
        }
    };

    const handleCancelGroup = (groupId) => {
        if (isEditing === groupId) {
            const originalData = savedData.find(
                (data) => data.groupId === groupId
            );
            setB3FormFields((prevFields) =>
                prevFields.map((group) =>
                    group.groupId === groupId
                        ? {
                            ...group,
                            fields: originalData.fields.map((field) => ({
                                formId: field.formId,
                                value: field.value,
                                originalValue: field.value,
                            })),
                        }
                        : group
                )
            );
        } else if (B3FormFields.length > 1) {
            setB3FormFields((prevFields) =>
                prevFields.filter((group) => group.groupId !== groupId)
            );
        } else {
            // alert("At least one form group is required.");
        }
        setIsEditing(null);
    };

    const handleEditRow = (row) => {
        const obj1 = row.fields;
        const updated_fields= JSON.parse(JSON.stringify(fields));
            updated_fields.forEach((field) => {
            // Check if the name key in fields exists in obj1
            if (obj1.hasOwnProperty(field.name)) {
                // If match, add a value property with the corresponding value from obj1
                field.value = obj1[field.name];
            }
            return field;
        });
        setB3FormFields(() => [
            {
                groupId: row.groupId,
                fields: updated_fields,
            },
        ]);
    };

    const handleDeleteRow = (groupId) => {
        setSavedData((prevData) =>
            prevData.filter((row) => row.groupId !== groupId)
        );
        setIsEditing(null);
    };

    const handleChange = (groupId, fieldName, value) => {
        handleEditB3Form(groupId, fieldName, { value });
    };

    const constructInitialvalues = () => {
        const initialvalues = {};
        fields.forEach((item) => {
            initialvalues[item.name] = "";
        });
    };

    const loadOptions = (inputValue, inputOptions, callback) => {
        setTimeout(() => {
            const optionsArray = Array.isArray(inputOptions) ? inputOptions : [];
            const data = inputValue ? optionsArray.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase())) : optionsArray;

            callback(data)
        }, 1000);
    };

    useEffect(() => {
        constructInitialvalues();
    }, []);

    return (
        <div className="fuel-eu-table-dynamic-form">

            <div style={{ marginTop: "20px",borderRadius:'0.25rem' }}>
                {savedData.length > 0 ? (
                    <table
                    >
                        <thead>
                            <tr>
                                {fields.map((item) => {
                                    return <th>{item.label}</th>;
                                })}
                                <th></th>
                                </tr>
                        </thead>
                        <tbody>
                            {savedData?.map((group) => (
                                <tr
                                key={`${group.groupId}`}
                                >
                                    {Object.keys(group.fields)?.map((field) => (
                                        <td>{group.fields[field]}</td>
                                    ))}
                                    <td>
                                        <IconButton
                                            onClick={() => {
                                                handleEditRow(group);
                                            }}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton
                                            color="error"
                                            onClick={() => handleDeleteRow(group.groupId)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : ''}
            </div>

            {B3FormFields.map((group) => {
                return <div style={{ border: '1px solid #ced4da' }}>
                    <MDBRow>
                        {group.fields?.map((field, index) => (
                            <MDBCol md="6">
                                <div className="m-3">
                                    <label>{field.label}{field.required && <sup style={{ color: 'red' }}>*</sup>}</label>
                                    <br />
                                    {field.type === 'input' && (
                                        <Input
                                            className="form-input"
                                            type={field.dataType || 'text'}
                                            autoFocus={false}
                                            placeholder={field.placeholder}
                                            required={field.required}
                                            defaultValue={field.value ? field.value : ''}
                                            value={field.value ? field.value : ''}
                                            onChange={(e) => handleChange(
                                                group.groupId,
                                                field.name,
                                                e
                                            )}
                                        />
                                    )}
                                    {field.type === 'textarea' && (
                                        <TextArea
                                            rows={3}
                                            className="textarea-resize textarea-form-input"
                                            placeholder={field.placeholder}
                                            autoFocus={false}
                                            required={field.required}
                                            defaultValue={field.value ? field.value : ''}
                                            value={field.value ? field.value : ''}
                                            onChange={(e) => handleChange(
                                                group.groupId,
                                                field.name,
                                                e
                                            )}
                                        />
                                    )}
                                    {field.type === 'dropdown' && (
                                        <AbsDropDown
                                            options={field.options}
                                            autoFocus={false}
                                            value={field.value ? field.value : null}
                                            selected={field.value ? field.value : null}
                                            handleChange={(e) => handleChange(
                                                group.groupId,
                                                field.name,
                                                e.value
                                            )}
                                            placeholder={' '}
                                        />
                                    )}
                                    {field.type === 'auto-dropdown' && (
                                        <AsyncSelect
                                            cacheOptions
                                            key={index}
                                            defaultOptions={field.options}
                                              value={field.multi?field?.value?field.value.map(val => ({
                                                value: val,
                                                label: val
                                              })):
                                              '':
                                              {
                                                value: field.value,
                                                label: field.value
                                              }}
                                            loadOptions={(inputValue, callback) => {
                                                return loadOptions(inputValue, field.options, callback);
                                            }}
                                            onChange={(selectedOption) => handleChange(
                                                group.groupId,
                                                field.name,
                                                field.multi?
                                                selectedOption ? selectedOption.map(option => option.value) : []:
                                                selectedOption?.value
                                            )}
                                            placeholder="Select..."
                                            isClearable={true}
                              isMulti={field.multi}
                              />
                                    )}
                                </div>
                            </MDBCol>
                        ))}
                        <MDBCol>
                            <div className="m-2" style={{ marginTop: "10px" }}>
                                <Button className='ml-2 save-button' onClick={() => handleSaveGroup(group.groupId)}>
                                    SAVE
                                </Button>
                                <Button
                                    className="ml-3 save-button"
                                    style={{backgroundColor:'rgb(255, 255, 255)',color:'rgb(0, 42, 78)'}}
                                    variant='secondary'
                                    onClick={() => handleCancelGroup(group.groupId)}
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </MDBCol>
                    </MDBRow>

                </div>
            })}
            <Button
                onClick={() => { addFormGroup() }}
                startIcon={<Icon icon={ICONS.ADD} />}
                className="m-2 save-button"
            >
                ADD ANOTHER
            </Button>
        </div>
    );
};

export default DynamicTableForm;
